import React, { useEffect, useRef } from 'react';
import api from '../../services/api';

/**
 * SessionHeartbeat Component
 * 
 * Periodically sends a 'heartbeat' ping to the backend to:
 * 1. Keep the JWT session alive (if applicable)
 * 2. Track the active duration of the user session in the UserSession table
 * 3. Update the 'last_activity_at' timestamp for the current session
 * 
 * Interval: 2 minutes (120,000 ms)
 */
const SessionHeartbeat: React.FC = () => {
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const sendHeartbeat = async () => {
        try {
            // Only send heartbeat if a token exists
            const token = localStorage.getItem('token');
            if (!token) return;

            await api.post('/auth/heartbeat');
        } catch (error) {
            console.error('[SessionHeartbeat] Ping failed:', error);
        }
    };

    useEffect(() => {
        // Send immediate heartbeat on mount
        sendHeartbeat();

        // Set up interval for subsequent heartbeats (2 minutes)
        intervalRef.current = setInterval(sendHeartbeat, 120000);

        // Clean up interval on unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    // This component doesn't render anything
    return null;
};

export default SessionHeartbeat;
